import React from 'react'

export function ChevronLeftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#AFBCCC"
        stroke="#AFBCCC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.2"
        d="M11.091 3.09a.6.6 0 00-.848-.848L4.909 7.576a.6.6 0 000 .848l5.334 5.334a.6.6 0 00.848-.849L6.182 8l4.91-4.91z"
      />
    </svg>
  )
}
